import { ReactNode } from 'react';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';
import { SwiperModule } from 'swiper/types';

import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import 'swiper/css';

interface SwiperSliderProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => ReactNode;
  slidesPerView?: number;
  direction?: 'vertical' | 'horizontal';
  swiperOptions?: SwiperProps;
  modules?: Array<SwiperModule>;
  spaceBetween?: number;
}

const SwiperSlider = <T,>({
  items,
  renderItem,
  swiperOptions = {},
  slidesPerView = 1.8,
  direction,
  spaceBetween
}: SwiperSliderProps<T>) => {
  const validateItems = items.length < 5 ? [...items, ...items, ...items] : items;

  return (
    <Swiper
      direction={direction}
      spaceBetween={spaceBetween}
      centeredSlides={true}
      slidesPerView={slidesPerView}
      loop={true}
      loopAdditionalSlides={1}
      autoplay={{
        delay: 6000,
        disableOnInteraction: false
      }}
      pagination={{
        clickable: true
      }}
      modules={[Autoplay]}
      className={`cursor-grab`}
      breakpoints={{
        2550: {
          slidesPerView: 3
        },
        2400: {
          slidesPerView: 2.8
        },
        2350: {
          slidesPerView: 2.8
        },
        2250: {
          slidesPerView: 2.5
        },
        2000: {
          slidesPerView: 2.3
        },
        1950: {
          slidesPerView: 2.2
        },
        1850: {
          slidesPerView: 2.1
        },
        1800: {
          slidesPerView: 2
        },
        1700: {
          slidesPerView: 1.9
        },
        1600: {
          slidesPerView: 1.8
        },
        1500: {
          slidesPerView: 1.7
        },
        1400: {
          slidesPerView: 1.7
        },
        1300: {
          slidesPerView: 1.5
        },
        1200: {
          slidesPerView: 1.4
        },
        1150: {
          slidesPerView: 1.3
        },
        700: {
          slidesPerView: 1.2
        },
        0: {
          slidesPerView: 1
        }
      }}
      {...swiperOptions}
    >
      {validateItems.map((item, index) => (
        <SwiperSlide key={index}>{renderItem(item, index)}</SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SwiperSlider;
